import styled from '@emotion/styled'

/** Vertical stack holding the view heading, the perspective toggle and the tree itself. */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
